'use client';

import { useRunnerRequestController as useSharedRunnerRequestController } from '@agentteams/runner-request/ui/hooks/useRunnerRequestController';
import { useWebRunnerRequestControllerAdapter } from './useWebRunnerRequestAdapter';

export { hasPromptContent } from '../lib/runnerRequest';
export { useRunnerRequestController } from '@agentteams/runner-request/ui/hooks/useRunnerRequestController';
export type { OpenDaemonTriggerModalDetail } from '@agentteams/runner-request/ui/hooks/useRunnerRequestController';

type SharedArgs = Parameters<typeof useSharedRunnerRequestController>[0];

/**
 * 웹 어댑터(생성·이어쓰기 뮤테이션·피드백·Portal 결과 이동)를 바인딩한 컨트롤러.
 * 열기·제출·첨부 상태 전이는 공용 패키지가 소유한다.
 */
export const useDaemonTriggerModalController = (args: Omit<SharedArgs, 'adapter'>) => {
  const adapter = useWebRunnerRequestControllerAdapter(args.token, args.continueSourceTrigger?.id ?? null, args.t, {
    teamId: args.selectedTeamId,
    projectId: args.selectedProjectId,
  });
  return useSharedRunnerRequestController({ ...args, adapter });
};
